import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DisputesComponent } from './disputes/disputes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from 'src/app/shared/shared.module';
import { DisputeDetailsComponent } from './dispute-details/dispute-details.component';


const routes: Routes = [
  { path: '', component: DisputesComponent },
  { path: 'details', component: DisputeDetailsComponent }
]

@NgModule({
  declarations: [DisputesComponent, DisputeDetailsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    BsDropdownModule,
    SharedModule
  ]
})
export class DisputesModule { }
